import React from 'react';

import { Form, Input } from 'antd';

const LabelFormField = ({ name, locale, placeholder }) => (
  <Form.Item name={[name, 'translations', locale, 'label']} label={'Label'}>
    <Input placeholder={placeholder} />
  </Form.Item>
);

export default LabelFormField;
